"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * # startsWith
 * String.startsWith() polyfill from MDN
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith#Polyfill
 *
 * @param {String} string
 * @param {String} search
 * @param {Number} pos
 * @return  {Boolean}
 *
 * @example
 * startsWith('Hello World!', 'Hello');
 *
 * @module helpers/polyfill/starts-with.js
 */
function startsWith(string, search, pos) {
  return string.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}

exports.default = startsWith;
module.exports = exports["default"];
//# sourceMappingURL=starts-with.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@sabre/aven-spark/js/dist/helpers/polyfill/starts-with.js
// module id = 880
// module chunks = 0